module.exports = __webpack_public_path__ + "img/dz.5ea08ead.svg";